export function encodeObject(obj) {
    let filters = [];
    if (obj) {
        Object.keys(obj).forEach(function (k) {
            const value = obj[k];
            if (Array.isArray(value)) {
                value.forEach(function (v) {
                    filters.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
                });
            } else {
                filters.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);
            }
        });
    }
    return `&${filters.join("&")}`;
}